import { ContentStatus } from "../enums";

export class ContentStatusHelper {
  static getDescription(value: ContentStatus): string {
    switch (value) {
      case "UPLOADING":
        return "Uploading";
      case "READY":
        return "Ready";
      case "QUEUED":
        return "Queued";
      case "PROCESSING":
        return "Processing";
      case "ERROR":
        return "Error";
      default:
        return "Undefined";
    }
  }

  static getColor(value: ContentStatus): string {
    let color: string;

    switch (value) {
      case ContentStatus.Uploading:
        color = "#2962ff";
        break;
      case ContentStatus.Ready:
        color = "#418841";
        break;
      case ContentStatus.Queued:
        color = "#1890ff";
        break;
      case ContentStatus.Processing:
        color = "#2db7f5";
        break;
      case ContentStatus.Error:
        color = "#cc4444";
        break;
      default:
        color = "#555";
        break;
    }

    return color;
  }

  static getValue(value: string): ContentStatus {
    switch (value) {
      case "UPLOADING":
        return ContentStatus.Uploading;
      case "READY":
        return ContentStatus.Ready;
      case "QUEUED":
        return ContentStatus.Queued;
      case "PROCESSING":
        return ContentStatus.Processing;
      case "ERROR":
        return ContentStatus.Error;
      default:
        return ContentStatus.Ready;
    }
  }

  static getFilterOptions() {
    return [
      {
        text: ContentStatusHelper.getDescription(ContentStatus.Uploading),
        value: ContentStatus.Uploading,
      },
      {
        text: ContentStatusHelper.getDescription(ContentStatus.Ready),
        value: ContentStatus.Ready,
      },
      {
        text: ContentStatusHelper.getDescription(ContentStatus.Queued),
        value: ContentStatus.Queued,
      },
      {
        text: ContentStatusHelper.getDescription(ContentStatus.Processing),
        value: ContentStatus.Processing,
      },
      {
        text: ContentStatusHelper.getDescription(ContentStatus.Error),
        value: ContentStatus.Error,
      },
    ];
  }
}
